module.exports = __webpack_public_path__ + "static/img/c1.c2db53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c1.png
// module id = 256
// module chunks = 0 1 2 3 4 5 6 7 8 9